import React from 'react'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'

import { EMPLOYEE_TYPE_UNDERTAKING } from "../../js/const"
import { formatDate } from '../../js/utils'

import '../../css/employee-table.css'

const EmployeeTableFooter = ({ addEmployee, type }) => {
  let addButtonText = type === EMPLOYEE_TYPE_UNDERTAKING ? 'Add People undertaking lobbyist activities' : 'Add Other people'
  return (
    <div className="p-helper-clearfix" style={{ width: '100%' }}>
      <Button icon="pi pi-plus" label={addButtonText} onClick={() => addEmployee(type)} />
    </div>
  )
}
const RestrictionStartDateTemplate = rowData => {
  return <span>{formatDate(rowData['RestrictionStartDate'])}</span>
}

const RestrictionEndDateTemplate = rowData => {
  return <span>{formatDate(rowData['RestrictionEndDate'])}</span>
}

const StartDateTemplate = rowData => {
  return <span>{formatDate(rowData['StartDate'])}</span>
}

const EndDateTemplate = rowData => {
  return <span>{formatDate(rowData['EndDate'])}</span>
}
const DetailsOrCommentsTemplate = rowData => {
// show a fixed-height scrollable container for long comments
  const text = rowData['DetailsOrComments'] || ''
  return (
    <textarea
      readOnly
      value={text}
      title={text}
      rows={3}
      style={{
        width: '100%',
        resize: 'Both',       // allow user to expand if desired
        overflow: 'auto',
        whiteSpace: 'pre-wrap',   // preserve line breaks
        wordBreak: 'break-word',
        padding: '0.5rem',
        boxSizing: 'border-box',
        borderRadius: '4px',
        border: '1px solid #d9d9d9',
        background: 'transparent',
        outline:'none',
      }}
    />
  )
}

const EmployeeTable = ({ canSave, addEmployee, type, selectedEmployee, selectEmployee, employees, isAnnualReturn }) => {
  let footer = isAnnualReturn === false && canSave === true ? <EmployeeTableFooter addEmployee={addEmployee} type={type} isAnnualReturn={isAnnualReturn} /> : ''
  let isUndertakingLobbyistActivity = type === EMPLOYEE_TYPE_UNDERTAKING
  let columnDefinitions = [
    { field: 'Name', header: 'Name' },
    { field: 'Position', header: 'Position' }
  ]
  if (isUndertakingLobbyistActivity) {
    let undertakingLobbyistnColumns = [
      { field: 'StatDecFilename', header: 'Stat Dec File' }
  ]
    columnDefinitions = columnDefinitions.concat(undertakingLobbyistnColumns)
  }
  
  let dateColumns = [
    
    { field: 'StartDate', header: <div style={{ whiteSpace: 'normal', lineHeight: 1.1 }}>Employee<br/>Start Date</div>, body: StartDateTemplate },
    { field: 'EndDate', header: <div style={{ whiteSpace: 'normal', lineHeight: 1.1 }}>Employee<br/>End Date</div>, body: EndDateTemplate }
  ]
  columnDefinitions = columnDefinitions.concat(dateColumns)
  if (isUndertakingLobbyistActivity) {
  let restrictionColumns = [
      { field: 'Restriction', header: 'Restriction' },
      { field: 'OtherRestrictionDetails', header: 'Other Restriction Details' },
      { field: 'RestrictionStartDate', header: <div style={{ whiteSpace: 'normal', lineHeight: 1.1 }}>Restriction<br/>Start Date</div>, body: RestrictionStartDateTemplate },
      { field: 'RestrictionEndDate', header: <div style={{ whiteSpace: 'normal', lineHeight: 1.1 }}>Restriction<br/>End Date</div>, body: RestrictionEndDateTemplate }      
  ]
  columnDefinitions = columnDefinitions.concat(restrictionColumns)
  }
  if (isUndertakingLobbyistActivity ) {
    let undertakingLobbyistDetailsOrCommentsColumn = [
      { field: 'DetailsOrComments', header: <div style={{ whiteSpace: 'normal', lineHeight: 1.1 }}>Restriction<br/>Details/Comments</div>, body: DetailsOrCommentsTemplate }
    ]
    columnDefinitions = columnDefinitions.concat(undertakingLobbyistDetailsOrCommentsColumn)
  }

  let columns = columnDefinitions.map((col, i) => {
    return <Column key={col.field} field={col.field} header={col.header} body={col.body} /> 
  })
  
  // sort by end date descending with null dates on top
  employees.sort((a, b) => {
    if (b.EndDate === null) {
      return 1
    }
    else if (a.EndDate === null) {
      return -1
    } else {
      return new Date(b.EndDate) - new Date(a.EndDate)
    }
  })
  return (
    <DataTable value={employees} footer={footer} selectionMode="single" selection={selectedEmployee}
      onSelectionChange={(e) => selectEmployee(e, type)} className={"employee-table"} responsive={true}>
      {columns}
    </DataTable>
  )
}

export default EmployeeTable;


// WEBPACK FOOTER //
// ./src/components/employee/employee-table.js